import { cn } from "@nwga/ui/lib/utils";
import type * as React from "react";

/**
 * The centred max-width wrapper, matching the main site's `Container.astro`.
 *
 * Gutters and measures agreeing across the two sites is most of what makes
 * them feel like one property — a page whose content starts 16px further left
 * than the last one reads as a different website even when the colours match.
 */
const WIDTHS = {
	narrow: "max-w-3xl",
	default: "max-w-6xl",
	wide: "max-w-7xl",
} as const;

export function Container({
	className,
	size = "default",
	...props
}: React.ComponentProps<"div"> & { size?: keyof typeof WIDTHS }) {
	return (
		<div
			className={cn(
				"mx-auto w-full px-4 sm:px-6 lg:px-8",
				WIDTHS[size],
				className,
			)}
			{...props}
		/>
	);
}
